import MediaCarousel from "@components/MediaCarousel"
import { getIn } from "@utils/index"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulMediaCarouselProps extends ContentfulContentBaseProps {}

const ContentfulMediaCarousel = ({
  blockId,
  hideControls,
  items,
}: ContentfulMediaCarouselProps) => (
  <MediaCarousel
    blockId={blockId}
    hideControls={hideControls}
    items={items.map((item) => ({
      ...item,
      image: getIn(item, "image.file.url"),
      mobileImage: getIn(item, "mobileImage.file.url"),
    }))}
  />
)

export default ContentfulMediaCarousel
